
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys/vargas",
      function () {
        return require("private-next-pages/attorneys/vargas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys/vargas"])
      });
    }
  